import { useState, useEffect } from "react";
import useCheerStore, { CHEER_EVENTS } from "../store/cheerStore";

export default function CheerModal() {
  const { cheer, dismiss } = useCheerStore();
  const [imgError, setImgError] = useState(false);

  useEffect(() => { setImgError(false); }, [cheer?.eventType]);

  if (!cheer) return null;

  const meta = CHEER_EVENTS.find(e => e.key === cheer.eventType) ?? CHEER_EVENTS[3];
  const showMascot = meta.mascot && !imgError;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
      onClick={dismiss}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full mx-4 overflow-hidden"
        style={{ maxWidth: 800 }}
        onClick={e => e.stopPropagation()}
      >
        {/* Mascot — full-width cover, upper half */}
        {showMascot && (
          <img
            src={meta.mascot}
            alt={meta.label}
            onError={() => setImgError(true)}
            className="w-full object-cover"
            style={{ height: 500 }}
          />
        )}

        {/* Event chip + title */}
        <div className="text-center px-10 pt-7 mb-4">
          <span className="inline-block text-xs font-semibold uppercase tracking-widest text-gray-400 mb-2">
            {meta.label}
          </span>
          <p className="text-3xl font-bold text-gray-900">{meta.title}</p>
        </div>

        {/* Cheer text card */}
        <div className="mx-8 mb-7 bg-gray-100 rounded-xl px-6 py-5">
          <p className="text-xl text-gray-700 leading-relaxed italic text-center">
            &ldquo;{cheer.text}&rdquo;
          </p>
        </div>

        {/* CTA */}
        <div className="px-10 pb-5 flex justify-center">
          <button
            onClick={dismiss}
            className="bg-bh-600 hover:bg-bh-700 text-white text-sm font-semibold px-10 py-3 rounded-lg transition-colors"
          >
            {meta.cta}
          </button>
        </div>

        {/* Subtitle */}
        {cheer.subtitle ? (
          <p className="text-center text-xs text-gray-400 pb-7 px-10">{cheer.subtitle}</p>
        ) : (
          <div className="pb-5" />
        )}
      </div>
    </div>
  );
}
